import { difference, isPlainObject } from 'lodash-es'

export const isEqual = (a, b, shouldSort = true) => {
  const x = Array.isArray(a) && shouldSort ? [...a].sort() : a
  const y = Array.isArray(b) && shouldSort ? [...b].sort() : b

  return JSON.stringify(x) === JSON.stringify(y)
}

export const isCancelError = (obj) => Object.getPrototypeOf(obj).__CANCEL__

export const getComparisonPercentage = (currentValue, previousValue) => {
  switch (previousValue) {
    case currentValue:
      return 0

    case 0:
      return 100
  }

  return Number((((currentValue - previousValue) / previousValue) * 100).toFixed(2))
}

export const getRowAndCol = (index, columns) => ({
  row: Math.floor(index / columns) + 1,
  col: (index % columns) + 1,
})

export const encodeQueryParam = (payload) => {
  const encode = (item) => item.toString().replaceAll(' ', '_')

  if (Array.isArray(payload)) {
    return payload.map(encode).join(',')
  }

  if (isPlainObject(payload)) {
    return JSON.stringify(payload)
  }

  return encode(payload)
}

export const decodeQueryParam = (payload, outputFormat = 'arr') => {
  const decode = () => payload.split(',').map((item) => item.replaceAll('_', ' '))
  switch (outputFormat) {
    case 'arr':
      return decode()
    case 'object':
      return JSON.parse(payload)
    case 'str':
      return decode().join('')
  }
}

export const capitalize = (value) => value[0].toUpperCase() + value.slice(1)

export const replaceFirstDash = (value) => {
  if (!value.startsWith('-')) {
    return value.toString()
  }

  return value.slice(1)
}

export const toFixedNumber = (value, digits, base) => {
  const pow = Math.pow(base || 10, digits)

  return Math.round(value * pow) / pow
}

export const differentKeys = (oldObj, newObj) => {
  const oldKeys = Object.keys(oldObj)
  const newKeys = Object.keys(newObj)

  return [
    ...oldKeys.filter((key) => !isEqual(oldObj[key], newObj[key], false)),
    ...difference(newKeys, oldKeys),
  ]
}

export const waitUntil = (condition, interval, timeout) =>
  new Promise((resolve, reject) => {
    const intervalId = setInterval(() => {
      if (condition()) {
        clearInterval(intervalId)
        resolve()
      }
    }, interval)

    if (timeout) {
      setTimeout(() => {
        clearInterval(intervalId)
        reject()
      }, timeout)
    }
  })

export const getFixedNumber = (num) => parseFloat(num.toFixed(2))
